import {
  Button, Form, Input, Rate, Select, Typography, message, Card, Spin,
} from 'antd';
import { useCallback, useState } from 'react';
import { useMutation } from 'react-query';
import { useProductsList } from 'hooks/api';
import { addReview } from 'services/product.service';

const { Title } = Typography;
const { Option } = Select;

const ReviewsCreate = () => {
  const [form] = Form.useForm();
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [selectedLink, setSelectedLink] = useState<string | null>(null);

  const { data: productsData, isLoading: productsLoading } = useProductsList();
  const { mutateAsync: submitReview, isLoading: submitting } = useMutation(addReview);

  const products: any[] = (productsData as any)?.data || [];

  const handleProductChange = useCallback((productId: string) => {
    const product = products.find((p: any) => p._id === productId);
    setSelectedProduct(product || null);
    setSelectedLink(null);
    form.setFieldsValue({ link: undefined });
  }, [products, form]);

  const handleFinish = useCallback(async (values: any) => {
    if (!selectedLink) {
      message.error('Please select a value');
      return;
    }
    await submitReview({
      link: selectedLink,
      review: {
        name: values.name,
        stars: values.stars,
        description: values.description,
      },
    });
    message.success('Review added!');
    form.resetFields();
    setSelectedProduct(null);
    setSelectedLink(null);
  }, [selectedLink, submitReview, form]);

  return (
    <Card style={{ maxWidth: 600, margin: '24px auto' }}>
      <Title level={4}>Add Review</Title>
      {productsLoading ? (
        <Spin />
      ) : (
        <Form form={form} layout='vertical' onFinish={handleFinish}>
          <Form.Item label='Product' required>
            <Select
              showSearch
              placeholder='Select a product'
              optionFilterProp='children'
              onChange={handleProductChange}
            >
              {products.map((p: any) => (
                <Option key={p._id} value={p._id}>{p.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label='Value' required>
            <Select
              placeholder='Select a value'
              disabled={!selectedProduct}
              value={selectedLink ?? undefined}
              onChange={(val) => setSelectedLink(val)}
            >
              {selectedProduct?.values?.map((v: any) => (
                <Option key={v.link} value={v.link}>
                  {v.display || v.originPrice}
                  —
                  { v.region }
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Enter name' }]}>
            <Input placeholder='Reviewer name' />
          </Form.Item>

          <Form.Item name='stars' label='Stars' rules={[{ required: true, message: 'Select rating' }]}>
            <Rate />
          </Form.Item>

          <Form.Item name='description' label='Description' rules={[{ required: true, message: 'Enter description' }]}>
            <Input.TextArea rows={4} placeholder='Review text' />
          </Form.Item>

          <Button type='primary' htmlType='submit' loading={submitting}>
            Submit
          </Button>
        </Form>
      )}
    </Card>
  );
};

export default ReviewsCreate;
